var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.161133,
    width: 13.6774,
    height: 13.6774,
    rx: 6.8387,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41599 7.55993L6.41599 9.83853L7.35628 9.83853L7.35628 7.55993L9.67725 7.55993L9.67725 6.45246L7.35628 6.45246L7.35628 4.16113L6.41599 4.16113L6.41599 6.45246L3.99981 6.45246L3.99981 7.55993L6.41599 7.55993Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f3e351d5a8b01d3834be02a62bf99d42.svg";
export { ForwardRef as ReactComponent };